import { start } from './websockets';

export default {
    install: (app, options) => {
      start();
    }    
};
  